import * as yup from 'yup';
import { passwordRule, confirmPasswordRule } from 'utils/validation-rules';

export const ResetPasswordSchema = yup.object({
  password: passwordRule,
  password_confirm: confirmPasswordRule('password'),
});
